export default __webpack_public_path__ + "static/hunter-leaman-b3a22f1f6c5ee38cd6dfab4daaea73f2.png";